import '.a{display:flex;}.ssr-plugin'
import '.hy{background-color:white;}.ssr-plugin'
import '.hz{border-radius:20px;}.ssr-plugin'
import '.am{border:var(--blue-border);}.ssr-plugin'
import '.q{overflow:hidden;}.ssr-plugin'
import '.bp{padding:1rem;}.ssr-plugin'
import '.u{width:100%;}.ssr-plugin'
import '.bq{align-items:flex-start;}.ssr-plugin'
import '.c3{background-color:var(--shades-blue-50);}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.g{justify-content:center;}.ssr-plugin'
import '.i0{width:6.1875rem;}.ssr-plugin'
import '.i1{height:7.6875rem;}.ssr-plugin'
import '.i2{border-radius:9px;}.ssr-plugin'
import '.al{gap:0.5rem;}.ssr-plugin'
import { styled } from 'inlines'
import { Text } from '@app/components/core/typography/Text'
import Column from '@app/components/layout/Column'

export interface EventProps {
  date: number
  month: string
  category: string
  title: string
  description?: string
  time: string
  location: string
  onClick?: () => void
}

export const Event = ({
  date,
  month,
  category,
  title,
  description = '',
  time,
  location,
  onClick,
}: EventProps) => {
  return (
    <div className="a hy hz am q bp u bq"
      onClick={onClick}
      style={{
        cursor: onClick ? 'pointer' : 'default',}}
    >
      {/* Date Section */}
      <div className="c3 bp a b c g i0 i1 i2"
      >
        <Text.Large
          style={{
            fontSize: '3.6rem',
            fontWeight: '700',
            color: 'var(--shades-blue-500)',
            lineHeight: '1',
            margin: 0,
          }}
          color="var(--shades-blue-500)"
        >
          {date}
        </Text.Large>
        <Text.ExtraSmall color="var(--shades-blue-500)">
          {String(month).toUpperCase()}
        </Text.ExtraSmall>
      </div>

      {/* Event Details Section */}
      <Column
        style={{
          padding: '0 1rem',
          flex: 1,
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          minHeight: '7.6875rem',
        }}
      >
        <div className="al">
          {/* Category */}
          <Text.ExtraSmall
            isBold={true}
            style={{ marginBottom: '0.5rem' }}
            color="var(--primary-red)"
          >
            {category.toUpperCase()}
          </Text.ExtraSmall>

          {/* Title */}
          <Text.Medium
            style={{
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              marginBottom: '0.5rem',
            }}
            color="var(--primary-blue)"
          >
            {title}
          </Text.Medium>

          {/* Description */}
          <Text.Small
            style={{
              lineClamp: 2,
            }}
            color="var(--shades-blue-600)"
          >
            {description}
          </Text.Small>
        </div>
        {/* Time and Location - aligned to bottom */}
        <styled.div>
          <Text.ExtraSmall
            style={{
              marginTop: '0.5rem',
              WebkitLineClamp: 1,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: '-webkit-box',
              WebkitBoxOrient: 'vertical',
            }}
            color="var(--primary-blue)"
          >
            {time} · {location}
          </Text.ExtraSmall>
        </styled.div>
      </Column>
    </div>
  )
}
